import { Image } from "antd";
import BranchListItemComponent from "./branches/BranchListItemComponent";
import AddIcon from "../images/Add";
import useUserStore from "../../stores/store";
import { useNavigate } from "react-router-dom";
import { convertTo12hr, getStatusColor, serverImgFullPath } from "../../utils/Common";

export default function RestaurantDetailComponent({
  setIsBranchStatusChange,
  records = {
    restaurant: {
      banner: "",
      categories: [],
      openTime: "",
      closeTime: "",
      images: [],
      logo: "",
      name: "",
      openDays: [],
      status: "",
      inventoryType: "",
      tableManagement: "Inactive"
    },
    restaurantId: "",
    loading: true,
    branches: [],
  },
}) {
  const { restaurant, branches } = records;
  const navigate = useNavigate();
  const { networkCall } = useUserStore();

  function onHandleAddBrunch() {
    navigate(`/restaurants/${records.restaurantId}/branch/create?restaurantName=${restaurant.name}`);
  }

  return (
    <section>
      <div className={"bg-[#FAFAFA]"}>
        <div className="min-h-[643px] p-[10px]">
          <div className="w-full h-full">
            {/* banner */}
            <div className="text-center max-h-[251px] w-full relative detail-banner-img">
              <Image
                src={restaurant.banner}
                preview={false}
                fallback={"/images/temp-restaurant-banner.jpg"}
                height={251}
                className="w-full"
              />
              {/* restaurant profile header */}
              <div className="px-[40px] w-full absolute bottom-[-50px]">
                {/* profile picture */}
                <div className="relative">
                  <div
                    className="w-[74px] h-[74px] bg-[#572D86] 
                flex items-center justify-center rounded-full"
                  >
                    <Image
                      src={serverImgFullPath(restaurant.logo)}
                      fallback="/images/icons/user.svg"
                      width={50}
                      height={50}
                      preview={false}
                      className="rounded-full"
                      alt="profile-picture"
                    />
                  </div>
                  <div
                    className="absolute left-[80px] bottom-[-13px] flex items-center 
                    justify-between w-[calc(100%-80px)] font-p_bold text-[20px]"
                  >
                    {restaurant.name}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* detail section */}

          <div className="w-full h-auto mt-[90px] pl-[30px]">
            <div className="flex items-center space-x-[10px] pb-[15px]">
              <Image src="/images/icons/time.svg" width={19.5} height={19.5} alt="time" preview={false} />
              <div className="font-p_regular text-[14px] leading-[21px] text-[#F58B29]">
                <span className="font-p_medium">Open </span>
                {convertTo12hr(restaurant.openTime)} {" - "}
                <span className="font-p_medium">Close </span>
                {convertTo12hr(restaurant.closeTime)}
              </div>
            </div>
            <div className="flex items-center space-x-[10px] pb-[15px]">
              <Image src="/images/icons/calendar.svg" alt="days" preview={false} width={19.5} height={19.5} />
              <div className="flex space-x-[10px]">
                <div className="font-p_medium">Open days: </div>
                {restaurant.openDays.map((d, idx) => {
                  return (
                    <span key={idx} className="font-p_regular text-[#828282]">
                      {d}
                    </span>
                  );
                })}
              </div>
            </div>
            <div className="flex items-center font-p_medium space-x-[10px]">
              <div className={`bg-[${getStatusColor(restaurant.status)}] h-[20px] w-[20px] rounded-full`}></div>
              <div className="text-[#828282]">{restaurant.status}</div>
            </div>
          </div>

          <div className="mt-[80px]">
            <div className="flex justify-between">
              <h1 className="text-[24px] leading-[24px] text-black">
                <span className="font-p_bold">Branches </span>
              </h1>
              <button
                className="bg-[#FCBD10] w-[100px] h-[40px] flex 
                items-center gap-x-[5px] rounded-lg"
                onClick={onHandleAddBrunch}
              >
                <div className="pl-2">
                  <AddIcon
                    attributes={{
                      size: "15.6",
                      color: "#000000",
                    }}
                  />
                </div>
                <p className="font-p_bold text-[15px] pl-[2px]">Branch</p>
              </button>
            </div>

            {networkCall === false && branches.length < 1 ? (
              <div className="min-h-[243px] flex items-center justify-center">
                <h1 className="font-p_semibold text-[20px]">No Branch found yet. You can add it...</h1>
              </div>
            ) : (
              branches.map((branch, idx) => {
                return (
                  <div key={idx}>
                    <BranchListItemComponent
                      setIsBranchStatusChange={setIsBranchStatusChange}
                      records={{
                        data: {
                          branchId: branch.id,
                          restaurantId: branch.parentRestaurantId,
                          restaurantName: branch.name,
                          branchName: branch.branch,
                          logo: branch.logo,
                          address: branch.address,
                          phoneCountryCode: branch.countryCode,
                          phone: branch.phone,
                          branchStatus: branch.status,
                          slug: branch.slug,
                          inventoryType: branch.inventoryType,
                          tableManagement: branch.tableManagement,
                          openingDate: ""
                        },
                      }}
                    />
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
